export default {
  UNPAID: 0,
  PARTIALLY_PAID: 1,
  PAID: 2,
  CANCELED: 3,
};
